// src/hooks/useApi.js
import { useContext, useCallback } from 'react';
import { AuthContext } from '../context/AuthContext';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

export const useApi = () => {
    const { logout } = useContext(AuthContext);

    const callApi = useCallback(async (endpoint, method = 'GET', body = null) => {
        try {
            const token = localStorage.getItem('token');
            const options = {
                method,
                headers: { 'Authorization': `Bearer ${token || ''}` },
            };

            if (body) {
                options.headers['Content-Type'] = 'application/json';
                options.body = JSON.stringify(body);
            }

            const response = await fetch(`${API_BASE_URL}/${endpoint}`, options);

            if (response.status === 401) {
                logout();
                return { success: false, error: 'Session expired. Please log in again.' };
            }

            if (!response.ok) {
                let errorMessage = `API call failed: ${response.statusText}`;
                try {
                    // Try to parse as JSON first
                    const errorData = await response.json();
                    errorMessage = errorData.message || errorMessage;
                } catch (jsonError) {
                    // ✅ FIX: If it fails to parse (e.g. returns HTML Doctype), catch it cleanly
                    console.error("API returned non-JSON error (likely HTML fallback):", jsonError);
                    errorMessage = `Server Error (${response.status}). Please ensure your backend is running and the route exists.`;
                }
                throw new Error(errorMessage);
            }

            if (response.status === 204) {
                return { success: true, data: null };
            }

            const data = await response.json();
            return { success: true, data };

        } catch (error) {
            console.error(`API Hook Error on ${endpoint}:`, error);
            return { success: false, error: error.message };
        }
    }, [logout]);

    return callApi;
};